/**
 *  M U T A T I O N S  (commit)
 *  https://vuex.vuejs.org/en/mutations.html
 */

const mutations = {
  RESET_STATE(state) {
    if (state.account) state.account = null
    if (state.token) state.token = null
    if (state.facility) state.facility = null
    if (state.facilities) state.facilities = null
    if (state.programs) state.programs = null
    if (state.facilityThreshold) state.facilityThreshold = null
    if (state.utility) state.utility = null
    if (state.iso) state.iso = null
  },
  SET_ACCOUNT(state, payload) {
    state.account = payload.account
    sessionStorage.setItem('account', JSON.stringify(payload.account))
  },
  SET_USER_TOKEN(state, payload) {
    state.token = payload.token
    sessionStorage.setItem('token', payload.token)
  },
  SET_FACILITY(state, payload) {
    state.facility = payload.facility
    sessionStorage.setItem('facility', JSON.stringify(payload.facility))
  },
  SET_FACILITIES(state, payload) {
    state.facilities = payload.facilities
    sessionStorage.setItem('facilities', JSON.stringify(payload.facilities))
  },
  SET_PROGRAMS(state, payload) {
    state.programs = payload.programs
    sessionStorage.setItem('programs', JSON.stringify(payload.programs))
  },
  SET_FACILITY_THRESHOLD(state, payload) {
    state.facilityThreshold = payload.threshold
    sessionStorage.setItem('threshold', payload.threshold)
  },
  SET_ISO(state, payload) {
    state.iso = payload.iso
    sessionStorage.setItem('iso', JSON.stringify(payload.iso))
  },
  SET_UTILITY(state, payload) {
    state.utility = payload.utility
    sessionStorage.setItem('utility', JSON.stringify(payload.utility))
  },
  SET_NOTICE(state, payload) {
    state.notice = payload
  },
  SET_NCP_CEILING(state, payload) {
    state.ncpCeiling = payload.ceiling
    sessionStorage.setItem('ncpCeiling', JSON.stringify(payload.ceiling))
  }
}

export default mutations
